import Confirm from 'app/components/Confirm';

import CheckBox from './CheckBox';
import PricePlan from './PricePlan';
import RegionSelect from './RegionSelect';
import TextField from './TextField';

const components = {
  CheckBox,
  PricePlan,
  RegionSelect,
  TextField,
  Confirm,
};
export default components;
